module.exports = __webpack_public_path__ + "static/media/hunt.4cd35cfc.jpg";